import React from 'react';
import { DeliverySummary } from '../../../../app/services/api/generated';
import { RetailerHeaderModel } from '../../../../app/services/api/ofdClient';
import WeightedPointsMap from '../components/WeightedPointsMap';

interface DeliveriesByMarketProps {
  deliveries: DeliverySummary[];
  retailers: RetailerHeaderModel[];
}

const DeliveriesByMarket = ({ deliveries, retailers }: DeliveriesByMarketProps) => {
  const heatmapData = deliveries
    .map(d => {
      const retailer = retailers.find(r => r.name === d.retailer);
      if (retailer && retailer.latitude && retailer.longitude) {
        return {
          location: { lat: retailer.latitude, lng: retailer.longitude },
          weight: d.shortages,
        };
      }
      return null;
    })
    .filter((h): h is { location: { lat: number; lng: number }; weight: number } => !!h);

  return <WeightedPointsMap points={heatmapData} />;
};

export default DeliveriesByMarket;
